import styled from "styled-components"

import {AvailableCurrency} from "@irati-web/wallet/src/components/WalletBalanceCard/styled"
import mainTheme from "@irati/ui/src/global/theme"

export const CurrencyContainer = styled(AvailableCurrency)`
  color: ${(props) => props.color ? props.color : mainTheme.colors.tertiary.g_400};
`

export const ImageCard = styled.img`
  width: ${mainTheme.spacing.eight};
  height: ${mainTheme.spacing.eight};
`
